import overArg from './_overArg.js';

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

export default getPrototype;



//////////////////
// WEBPACK FOOTER
// /app/node_modules/lodash-es/_getPrototype.js
// module id = 570
// module chunks = 1